import { IonLabel } from "@ionic/react";
import { GroupChannel } from "@sendbird/chat/groupChannel";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { OFFICIAL, PINNED } from "../../../utils/channelStatus";
import { OfficialIcon } from "./OfficialIcon";
import { PinnedIcon } from "./PinnedIcon";

export const ChannelTitle = (props: { channel: GroupChannel | null; currentUserId: number | undefined }) => {
  const [isPinned, setIsPinned] = useState<boolean>(false);
  const [isOfficial, setIsOfficial] = useState<boolean>(false);
  const [title, setTitle] = useState<string | null>("...");

  useEffect(() => {
    if (!props.channel?.name && !props.channel?.members) {
      setTitle(t("No title"));
    } else if (props.channel?.name && props.channel.name.toLowerCase() !== "group channel") {
      setTitle(props.channel.name);
    } else if (props.channel?.members?.length === 1) {
      setTitle(t("noMembers"));
    } else {
      setTitle(
        (props.channel?.members || [])
          .filter(({ userId }) => userId !== props.currentUserId?.toString())
          .map(({ nickname }) => nickname || t("noName"))
          .join(", "),
      );
    }
  }, [props.channel?.name, props.channel?.members, props.currentUserId]);

  useEffect(() => {
    setIsPinned(props.channel?.customType.includes(PINNED) || false);
    setIsOfficial(props.channel?.customType.includes(OFFICIAL) || false);
  }, [props.channel?.customType]);

  return (
    <IonLabel className={"channel-preview__title"}>
      {isPinned ? <PinnedIcon /> : ""}
      {isOfficial ? <OfficialIcon /> : ""}
      {title}
    </IonLabel>
  );
};
